/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePccPatientRequest
 */
export interface CreatePccPatientRequest {
    /**
     * 
     */
    birth_date: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    middle_name?: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    gender: string;
    /**
     * 
     */
    medicaid_number?: string;
    /**
     * 
     */
    medicare_number?: string;
    /**
     * 
     */
    social_beneficiary_identifier?: string;
}

/**
 * Check if a given object implements the CreatePccPatientRequest interface.
 */
export function instanceOfCreatePccPatientRequest(value: object): value is CreatePccPatientRequest {
    if (!('birth_date' in value) || value['birth_date'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('gender' in value) || value['gender'] === undefined) return false;
    return true;
}

export function CreatePccPatientRequestFromJSON(json: any): CreatePccPatientRequest {
    return CreatePccPatientRequestFromJSONTyped(json, false);
}

export function CreatePccPatientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePccPatientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'birth_date': json['birth_date'],
        'facility_id': json['facility_id'],
        'first_name': json['first_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'last_name': json['last_name'],
        'gender': json['gender'],
        'medicaid_number': json['medicaid_number'] == null ? undefined : json['medicaid_number'],
        'medicare_number': json['medicare_number'] == null ? undefined : json['medicare_number'],
        'social_beneficiary_identifier': json['social_beneficiary_identifier'] == null ? undefined : json['social_beneficiary_identifier'],
    };
}

export function CreatePccPatientRequestToJSON(json: any): CreatePccPatientRequest {
    return CreatePccPatientRequestToJSONTyped(json, false);
}

export function CreatePccPatientRequestToJSONTyped(value?: CreatePccPatientRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'birth_date': value['birth_date'],
        'facility_id': value['facility_id'],
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'gender': value['gender'],
        'medicaid_number': value['medicaid_number'],
        'medicare_number': value['medicare_number'],
        'social_beneficiary_identifier': value['social_beneficiary_identifier'],
    };
}

